import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-standards-dialog',
    imports: [
        MatButtonModule
    ],
    templateUrl: './standards-dialog.component.html',
    styleUrl: './standards-dialog.component.css'
})
export class StandardsDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<StandardsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; path: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onOpen(): void {
    this.dialogRef.close('open');
  }

}
